import {updateLabelConfig} from '../../../data/labelInfos/index.js'
import {FEDEX, SHIPPO} from '../../../common/constants/ShipperNames.js'
import ConfigTextInput from './ConfigTextInput.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {
  defaultValidLabelPropertiesFunc,
  ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
} from './useLabelProperty.js'

const LABEL_PROPERTY = 'delivery_instructions'
const VALID_SHIPPER_TYPES = [FEDEX, SHIPPO]

export default function DeliveryInstructions() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = DeliveryInstructions.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  return (
    <ConfigTextInput
      label="Delivery Instructions"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {[labelProperty]: value})

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
    />
  )
}

DeliveryInstructions.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc() {
      return [LABEL_PROPERTY]
    },
    dependentPropertiesFunc: ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
